
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migracja-numeru/przeniesienie-niemozliwe",
      function () {
        return require("private-next-pages/migracja-numeru/przeniesienie-niemozliwe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migracja-numeru/przeniesienie-niemozliwe"])
      });
    }
  